// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"313":"core-components-deferred","511":"core-components","870":"vendors-editor","985":"vendors-extra"}[chunkId] + "." + {"313":"28f5427b","511":"7719f872","870":"e55db5cd","985":"3066aa3a"}[chunkId] + ".chunk.css";
};